import React from 'react';
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Company(props) {
    const [companyInfo, setCompanyInfo] = useState({
        addr1: '',
        addr2: '',
        phone1: '',email:'',
        phone2: '',sreg_no:''
    });

    const fetchData = () => {
        fetch('https://gtfundcrop.com/Rest5/company_profile_api')
            .then((response) => response.json())
            .then((data) => {
                setCompanyInfo({
                    addr1: data.head_office || '',
                    addr2: data.branch_office || '',
                    phone1: data.phone1 || '',
                    phone2: data.phone2 || '',
                    email: data.email || ''
                });
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="safearea bg-soft">
            <Helmet>
                <title>About Company | MCX Trading</title>
            </Helmet>

            {/* Modern Header */}
            <header className="app-header bg-primary text-white shadow-sm">
                <div className="container">
                    <div className="d-flex align-items-center py-3">
                        <Link to="/settings" className="btn btn-ghost-light me-2">
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                        <h1 className="h5 mb-0">About Company</h1>
                    </div>
                </div>
            </header>

            <main className="container py-4 mt-5">
                <div className="card border-0 shadow-sm rounded-lg overflow-hidden">
                    <div className="card-body p-4">
                        <div className="text-center mb-4">
                            <h2 className="fw-bold text-dark mb-3">GtFundCrop</h2>
                            <div className="divider bg-primary mx-auto" style={{width: '80px', height: '3px'}}></div>
                        </div>

                        <div className="company-info">
                            <div className="info-item mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-building text-primary me-2 fs-5"></i>
                                    <h3 className="h6 fw-bold mb-0 text-dark">Head Office</h3>
                                </div>
                                <p className="ps-4 text-muted">{companyInfo.addr1 || 'Loading...'}</p>
                            </div>

                            <div className="info-item mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-code-branch text-primary me-2 fs-5"></i>
                                    <h3 className="h6 fw-bold mb-0 text-dark">Branch Office</h3>
                                </div>
                                <p className="ps-4 text-muted">{companyInfo.addr2 || 'Loading...'}</p>
                            </div>

                            <div className="info-item mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-envelope text-primary me-2 fs-5"></i>
                                    <h3 className="h6 fw-bold mb-0 text-dark">Email</h3>
                                </div>
                                <p className="ps-4 text-muted">{companyInfo.email}</p>
                            </div>

                            <div className="info-item mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-phone text-primary me-2 fs-5"></i>
                                    <h3 className="h6 fw-bold mb-0 text-dark">Phone</h3>
                                </div>
                                <div className="ps-4">
                                    <p className="text-muted mb-1">{companyInfo.phone1 || 'Loading...'}</p>
                                    {companyInfo.phone2 && <p className="text-muted mb-0">{companyInfo.phone2}</p>}
                                </div>
                            </div>

                                                  
                        </div>

                        <div className="text-center mt-4">
                            <Link to="/contact" className="btn btn-outline-primary btn-sm px-4">
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}